module.exports = __webpack_public_path__ + "static/media/7.d2a07eb5.jpeg";